import "./facility.css";

import React from "react";

import { CONTACT, FACILITY_PAGE } from "../../data/content";
import PageMeta from "../general/PageMeta";
import PageBanner from "../general/PageBanner";
import PhotoStrip from "../general/PhotoStrip";
import Lightbox from "./Lightbox";

const Facility = () => {
  const [openIndex, setOpenIndex] = React.useState(null);

  return (
    <React.Fragment>
      <PageMeta title={FACILITY_PAGE.metaTitle} />
      <PageBanner />

      <section className={"facility dark-page"}>
        <div className={"container"}>
          <h1 className={"page-title"}>{FACILITY_PAGE.title}</h1>
          <p className={"facility-shops-heading"}>{FACILITY_PAGE.shopsHeading}</p>
          <p className={"facility-shops"}>
            {CONTACT.factoryShops.map((shop, i) => (
              <React.Fragment key={shop}>
                {i > 0 ? <br /> : null}
                {shop}
              </React.Fragment>
            ))}
          </p>
        </div>

        <ul className={"facility-gallery"}>
          {FACILITY_PAGE.images.map((img, i) => (
            <li key={img.full}>
              <button
                type={"button"}
                onClick={() => setOpenIndex(i)}
                aria-label={`View ${img.alt}`}
              >
                <img
                  src={img.thumb}
                  alt={""}
                  loading={i < 6 ? "eager" : "lazy"}
                />
              </button>
            </li>
          ))}
        </ul>
      </section>

      <PhotoStrip />

      {openIndex !== null ? (
        <Lightbox
          images={FACILITY_PAGE.images}
          index={openIndex}
          onChange={setOpenIndex}
          onClose={() => setOpenIndex(null)}
        />
      ) : null}
    </React.Fragment>
  );
};

export default Facility;
